/* eslint-disable import/no-cycle */
import { Component } from "react";
import { MenuItem } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "react-intl";
import { BadRequestError, ConflictError } from "../../api";
import {
  withNotifier,
  notifierShape,
  withRules,
  rulesShape,
  withApi,
  apiShape,
  withBrowser,
  browserShape,
} from "../../context";
import AllObjectsSelectModal from "../AllObjects/AllObjectsSelectModal";
import ConfirmationModal from "../ConfirmationModal";
import ItemMenu from "../ItemMenu";
import ListItem from "../List/ListItem";

import {
  accessRightsShape,
  nodeShape,
  assetShape,
  instrumentationShape,
  intlShape,
} from "../../shapes";

import { isNotEmpty, url } from "../../utils";
import SubscriptionAssignmentMenuItem from "../Subscriptions/SubscriptionAssigmentMenuItem";
import { FormattedNumber } from "../Format";
import { extractAccessRights } from "../../extractors/accessRightsExtractor";
import {
  getAssignedNodesChips,
  getSpecificationChips,
} from "../../utils/chipsUtils";

type Props = {
  instrumentation?: instrumentationShape;
  intl?: intlShape;
  onInstrumentationRemoved?: $TSFixMeFunction;
  onClick?: $TSFixMeFunction;
  showItemMenu?: boolean;
  parentNode?: nodeShape;
  parentAsset?: assetShape;
  parentAccessRights?: accessRightsShape;
  rules?: rulesShape;
  hideStatus?: boolean;
  notifier?: notifierShape;
  api?: apiShape;
  browser?: browserShape;
  options?: string[];
};

type State = $TSFixMe;

export class InstrumentationItem extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleOnItemMenuOpen = this.handleOnItemMenuOpen.bind(this);
    this.handleOnEditClick = this.handleOnEditClick.bind(this);
    this.handleOnConfirm = this.handleOnConfirm.bind(this);
    this.handleOnAssignClick = this.handleOnAssignClick.bind(this);
    this.handleOnUnassignClick = this.handleOnUnassignClick.bind(this);
    this.handleOnMoveAssignmentClick =
      this.handleOnMoveAssignmentClick.bind(this);
    this.handleOnModalClose = this.handleOnModalClose.bind(this);
    this.handleOnNodeSelect = this.handleOnNodeSelect.bind(this);
    this.handleOnDeleteClick = this.handleOnDeleteClick.bind(this);

    this.state = {
      accessRights: { canUpdate: false, canDelete: false, isLoading: true },
      assigning: false,
      unassigning: false,
      moving: false,
      deleting: false,
    };
  }

  async handleOnItemMenuOpen() {
    const { instrumentation, api, notifier } = this.props;
    try {
      const accessRights = extractAccessRights(
        "Instrumentation",
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        instrumentation.id,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        await api.get("/users/current/access_rights", {
          permitable_type: "Instrumentation",
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          permitable_id: instrumentation.id,
        }),
      );

      this.setState({ accessRights: { ...accessRights, isLoading: false } });
    } catch (error) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showError(api.translateError(error));
    }
  }

  handleOnEditClick() {
    const { instrumentation, browser } = this.props;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    browser.navigateTo(`/instrumentations/${instrumentation.id}/edit`);
  }

  async handleOnConfirm() {
    const {
      intl,
      onInstrumentationRemoved,
      parentNode,
      parentAsset,
      instrumentation,
      notifier,
      api,
    } = this.props;
    const { deleting, unassigning } = this.state;
    this.resetActionsState();
    if (deleting) {
      try {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        await api.delete(`/instrumentations/${instrumentation.id}`);
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showSuccess(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({
            id: "instrumentation.actions.delete.notification",
          }),
        );
        onInstrumentationRemoved?.(instrumentation);
      } catch (error) {
        if (error instanceof ConflictError)
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showError(
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({
              id: "api.error.instrumentation.assigned_restriction",
            }),
          );
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        else notifier.showError(api.translateError(error));
      }
    }
    if (unassigning) {
      try {
        if (parentNode) {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          await api.delete(`/nodes/${parentNode.id}/instrumentations`, {
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            instrumentations: [{ id: instrumentation.id }],
          });
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showSuccess(
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({
              id: "instrumentation.actions.unassign.notification",
            }),
          );
          onInstrumentationRemoved?.(instrumentation);
        } else if (parentAsset) {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          await api.delete(`/assets/${parentAsset.id}/instrumentations`, {
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            instrumentations: [{ id: instrumentation.id }],
          });

          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showSuccess(
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({
              id: "instrumentation.actions.unassign.notification",
            }),
          );
          onInstrumentationRemoved?.(instrumentation);
        }
      } catch (error) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(api.translateError(error));
      }
    }
    return null;
  }

  handleOnAssignClick() {
    this.setState({ assigning: true });
  }

  handleOnUnassignClick() {
    this.setState({ unassigning: true });
  }

  handleOnMoveAssignmentClick() {
    this.setState({ moving: true });
  }

  handleOnDeleteClick() {
    this.setState({ deleting: true });
  }

  handleOnModalClose() {
    this.resetActionsState();
  }

  async handleOnNodeSelect(node: $TSFixMe) {
    const {
      instrumentation,
      onInstrumentationRemoved,
      intl,
      parentNode,
      parentAsset,
      api,
      notifier,
    } = this.props;
    const { assigning, moving } = this.state;
    try {
      if (assigning && node) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        await api.post(`/instrumentations/${instrumentation.id}/nodes`, {
          nodes: [{ id: node.id }],
        });
        if (!parentNode && !parentAsset) {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showSuccess(
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({
              id: "instrumentation.actions.move_assignment.notification",
            }),
          );
          onInstrumentationRemoved?.(instrumentation);
        } else {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showSuccess(
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({
              id: "instrumentation.actions.assign.notification",
            }),
          );
        }
        this.resetActionsState();
      } else if (moving) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        await api.post(`/instrumentations/${instrumentation.id}/nodes`, {
          nodes: [{ id: node.id }],
        });
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        await api.delete(`/instrumentations/${instrumentation.id}/nodes`, {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          nodes: [{ id: parentNode.id }],
        });
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showSuccess(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({
            id: "instrumentation.actions.move_assignment.notification",
          }),
        );
        onInstrumentationRemoved?.(instrumentation);
        this.resetActionsState();
      }
    } catch (error) {
      if (error instanceof BadRequestError) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({ id: "instrumentation.actions.assign.error" }),
        );
      } else {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(api.translateError(error));
      }
    }
  }

  formatDetails(instrumentation: $TSFixMe) {
    let details = instrumentation.typeName ? instrumentation.typeName : "";

    if (isNotEmpty(details) && isNotEmpty(instrumentation.description)) {
      details = details.concat(", ");
    }

    if (isNotEmpty(instrumentation.description)) {
      details = details.concat(instrumentation.description);
    }

    if (instrumentation.statusCode === "inactive") {
      details = details.concat(` (${instrumentation.statusName})`);
    }

    return details;
  }

  resetActionsState() {
    this.setState({
      assigning: false,
      unassigning: false,
      moving: false,
      deleting: false,
    });
  }

  renderActions() {
    const {
      instrumentation,
      showItemMenu,
      intl,
      parentNode,
      parentAsset,
      parentAccessRights,
    } = this.props;

    const { canUpdate, canDelete, canPermit } = this.state.accessRights;
    const { assigning, moving, deleting, unassigning, assignedNodeIds } =
      this.state;

    return (
      <>
        <ItemMenu
          isLoading={this.state.accessRights.isLoading}
          onOpen={this.handleOnItemMenuOpen}
        >
          <MenuItem onSelect={this.handleOnEditClick} disabled={!canUpdate}>
            <FormattedMessage id="button.edit" />
          </MenuItem>
          {!!(showItemMenu && parentNode) && (
            <>
              <MenuItem
                onSelect={this.handleOnAssignClick}
                disabled={!canPermit}
              >
                <FormattedMessage id="button.assign" />
              </MenuItem>
              <MenuItem
                onSelect={this.handleOnUnassignClick}
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                disabled={!parentAccessRights.canUpdate || !canPermit}
              >
                <FormattedMessage id="button.unassign" />
              </MenuItem>
              <MenuItem
                onSelect={this.handleOnMoveAssignmentClick}
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                disabled={!parentAccessRights.canUpdate || !canPermit}
              >
                <FormattedMessage id="button.move" />
              </MenuItem>
            </>
          )}
          {!!(showItemMenu && !parentNode && !parentAsset) && (
            <MenuItem onSelect={this.handleOnAssignClick} disabled={!canPermit}>
              <FormattedMessage id="button.move" />
            </MenuItem>
          )}
          {!!(showItemMenu && parentAsset) && (
            <MenuItem
              onSelect={this.handleOnUnassignClick}
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              disabled={!parentAccessRights.canPermit || !canUpdate}
            >
              <FormattedMessage id="button.unassign" />
            </MenuItem>
          )}
          <MenuItem onSelect={this.handleOnDeleteClick} disabled={!canDelete}>
            <FormattedMessage id="button.delete" />
          </MenuItem>
          <SubscriptionAssignmentMenuItem
            // @ts-expect-error TS(2322) FIXME: Type '{ id: number | undefined; type: string; assi... Remove this comment to see the full error message
            id={instrumentation.id}
            type="instrumentation"
            assign
          />
          <SubscriptionAssignmentMenuItem
            // @ts-expect-error TS(2322) FIXME: Type '{ id: number | undefined; type: string; assi... Remove this comment to see the full error message
            id={instrumentation.id}
            type="instrumentation"
            assign={false}
          />
        </ItemMenu>
        {assigning || moving ? (
          <AllObjectsSelectModal
            // @ts-expect-error TS(2322) FIXME: Type '{ onClose: () => void; onSelectNode: (node: ... Remove this comment to see the full error message
            onClose={this.handleOnModalClose}
            onSelectNode={this.handleOnNodeSelect}
            canNavigateDisabledNodes
            disabledNodeIds={assignedNodeIds}
            type={
              ((parentNode || parentAsset) && assigning && "assign") || "move"
            }
          />
        ) : null}
        {deleting || unassigning ? (
          <ConfirmationModal
            // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape | undefined; id: string; s... Remove this comment to see the full error message
            intl={intl}
            id="confirmation-modal"
            show
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            titleText={intl.formatMessage({
              id: deleting
                ? "instrumentation.actions.delete.modal_title"
                : "instrumentation.actions.unassign.confirmation.title",
            })}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            messageText={intl.formatMessage({
              id: deleting
                ? "instrumentation.actions.delete.modal_message"
                : "instrumentation.actions.unassign.confirmation.message",
            })}
            onConfirm={this.handleOnConfirm}
            onClose={this.handleOnModalClose}
          />
        ) : null}
      </>
    );
  }

  render() {
    const { instrumentation, intl, onClick, rules, hideStatus, options } =
      this.props;

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const instrumentationRules = rules.instrumentation(
      instrumentation,
      (instrumentation as $TSFixMe).assets,
    );

    let status = (instrumentation as $TSFixMe).worstStatusCode || "undefined";
    if ((instrumentation as $TSFixMe).statusCode === "inactive") {
      status = status.concat(" inactive");
    }

    status = hideStatus ? "hidden" : status;

    const specifications = options?.includes("specifications")
      ? getSpecificationChips(
          (instrumentation as $TSFixMe).specifications,
          intl,
        )
      : undefined;
    const nodes = options?.includes("nodes")
      ? getAssignedNodesChips((instrumentation as $TSFixMe).nodes, intl)
      : undefined;

    return (
      <ListItem
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        id={`instrumentation-item-${instrumentation.id}`}
        icon="lcm-iot-icon-instrumentation"
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        title={instrumentation.tag}
        description={this.formatDetails(instrumentation)}
        // @ts-expect-error TS(2322) FIXME: Type '(() => any) | null' is not assignable to typ... Remove this comment to see the full error message
        onClick={onClick ? () => onClick(instrumentation) : null}
        status={status}
        target={
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          onClick ? undefined : url(`/instrumentations/${instrumentation.id}`)
        }
        specifications={specifications}
        nodes={nodes}
        value={
          (instrumentation as $TSFixMe).value ? (
            <>
              <FormattedNumber
                minimumFractionDigits={instrumentationRules.get(
                  "minDecimalDigits",
                  (instrumentation as $TSFixMe).value.key,
                )}
                maximumFractionDigits={instrumentationRules.get(
                  "maxDecimalDigits",
                  (instrumentation as $TSFixMe).value.key,
                )}
                value={(instrumentation as $TSFixMe).value.value}
              />
              <span>{` ${(instrumentation as $TSFixMe).value.unit}`}</span>
            </>
          ) : null
        }
        actions={this.renderActions()}
      />
    );
  }
}

export default withBrowser(
  // @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
  withApi(withNotifier(withRules(injectIntl(InstrumentationItem)))),
);
